<template>
	<Modal fullscreen>
		<template #title>
			<div class="font-h3-bold text-normal">{{ t('conflicts.header') }}</div>
		</template>

		<div class="flex flex-col">
			<div class="font-body-m mt-06 flex w-[29rem] flex-col gap-03 whitespace-pre-line">{{ t('conflicts.desc') }}</div>

			<Checkbox v-model="dontShowAgainCheckbox" class="mt-06" :value="true" :label="t('conflicts.dontShowAgain')">
				<template #label>
					<div class="text-normal">{{ t('conflicts.dontShowAgain') }}</div>
				</template>
			</Checkbox>

			<ButtonGroup variant="end" class="mt-06">
				<Button size="s" variant="secondary" @click="emit('openChangelog')">{{ t('conflicts.openChangelog') }}</Button>
				<Button size="s" variant="primary" @click="emit('continue', dontShowAgainCheckbox)">{{ t('conflicts.continue') }}</Button>
			</ButtonGroup>
		</div>
	</Modal>
</template>

<script setup lang="ts">
import { Button, ButtonGroup, Checkbox, Modal, useTranslation } from '@bluebrick/saas-ui'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { usePreferencesStore } from '@/features/preferences/usePreferencesStore'

const { t } = useTranslation()
const { didCheckDontShowConflictsModalAgain } = storeToRefs(usePreferencesStore())
const dontShowAgainCheckbox = ref(didCheckDontShowConflictsModalAgain.value)

const emit = defineEmits<{
	(e: 'openChangelog'): void
	(e: 'continue', hasCheckedDontShowAgain: boolean): void
}>()
</script>
